import { enabledPageGuard, isPageEnabled } from '@/lib/migration';
import { permissaoGuard } from '@/lib/permissions';
import {
  createFileRoute,
  stripSearchParams,
  type RegisteredRouter,
} from '@tanstack/react-router';
import { searchSchema } from './-schemas';
import { FILTRO_CLIENTES_PADRAO } from './-utils/filtro';

const ROTA_ALTERAR_DADOS =
  '/__authenticated/comercial/produto/clientes/web/$codigo/alterar-dados/' satisfies keyof RegisteredRouter['routesById'];

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes',
)({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(FILTRO_CLIENTES_PADRAO)],
  },
  beforeLoad: async ({ matches }) => {
    const rota = matches.at(-1)?.routeId;

    const podeAcessarAlterarDadosWeb =
      rota === ROTA_ALTERAR_DADOS && isPageEnabled('clientes.alterar-dados');

    if (!podeAcessarAlterarDadosWeb) {
      await enabledPageGuard('clientes', {
        redirectToOldSitePage: 'comercial/produto/clientes',
      });
    }

    await permissaoGuard('Clientes');
  },
});
